import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Select,
    MenuItem,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { InputLabel } from "@mui/material";
import moment from "moment";
import { ButtonTextGrid } from "../..";

interface PeopleCounterDialogProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (reportType: string, selectedMonth?: moment.Moment | null) => void;
}

export default function PeopleCounterDialog({
    open,
    onClose,
    onSubmit,
}: PeopleCounterDialogProps) {
    const [selectedReportType, setSelectedReportType] = useState<string>("");
    const [selectedMonth, setSelectedMonth] = useState<moment.Moment | null>(moment());

    useEffect(() => {
        if (open) {
            setSelectedReportType("");
            setSelectedMonth(moment());
        }
    }, [open]);

    const handleReportTypeChange = (event: any) => {
        setSelectedReportType(event.target.value);
    };

    const handleMonthChange = (date: moment.Moment | null) => {
        setSelectedMonth(date);
    };

    const handleSubmit = () => {
        if (!selectedReportType) {
            return;
        }
        
        if (!selectedMonth) {
            return;
        }

        const apiName = selectedReportType === "people_counter_129_25" 
            ? "129PeopleCounter" 
            : "139PeopleCounter";
        
        onSubmit(apiName, selectedMonth);
    };

    const handleClose = () => {
        setSelectedReportType("");
        setSelectedMonth(moment());
        onClose();
    };

    const canSubmit = selectedReportType !== "" && selectedMonth !== null;

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>下載人流報告</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <Box sx={{ mt: 3 }}>
                        <InputLabel htmlFor="report-type-select">選擇報告類型</InputLabel>
                        <Box sx={{ mt: 1 }}>
                            <Select
                                fullWidth
                                value={selectedReportType}
                                onChange={handleReportTypeChange}
                                displayEmpty
                            >
                                <MenuItem value="" disabled>
                                    請選擇報告類型
                                </MenuItem>
                                <MenuItem value="people_counter_129_25">129/25 - 人流報告</MenuItem>
                                <MenuItem value="people_counter_139_25">139/25 - 人流報告</MenuItem>
                            </Select>
                        </Box>
                    </Box>

                    {selectedReportType && (
                        <Box sx={{ mt: 3 }}>
                            <InputLabel htmlFor="month-picker">選擇月份</InputLabel>
                            <Box sx={{ mt: 1 }}>
                                <DatePicker
                                    views={['year', 'month']}
                                    onChange={handleMonthChange}
                                    value={selectedMonth}
                                    format="YYYY-MM"
                                />
                            </Box>
                        </Box>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={() => {
                        const link = document.createElement("a");
                        link.href = "/ESS Convert PDF.exe";
                        link.download = "ESS Convert PDF.exe";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }}
                >
                    <ButtonTextGrid>
                        下載 ESS Convert PDF.exe
                    </ButtonTextGrid>
                </Button>
                <Button onClick={handleClose}>
                    <ButtonTextGrid>
                        取消
                    </ButtonTextGrid>
                </Button>
                <Button
                    onClick={handleSubmit}
                    disabled={!canSubmit}
                >
                    <ButtonTextGrid>
                        提交
                    </ButtonTextGrid>
                </Button>
            </DialogActions>
        </Dialog>
    );
}

